<template>
    <b-navbar>
        <template slot="brand">
            <b-navbar-item tag="a" title="Abrir o menu" :class="{ 'is-hidden': sidebarIsOpened }" @click="setSidebar(true)">
                <b-icon icon="menu"></b-icon>
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <img src="@/assets/logo.png" alt="Sysplan" />
            </b-navbar-item>
        </template>
        <template slot="end">
            <b-navbar-item tag="div">
                <div class="buttons">
                    <router-link :to="{ name: 'atendimento', params: { id: 'novo' }}" class="button is-primary" title="Clique para abrir um atendimento">
                        <span class="icon">
                            <b-icon icon="account-tie-voice" custom-size="default" />
                        </span>
                        <span><span class="is-hidden-mobile">Solicitar </span>atendimento</span>
                    </router-link>
                    <a class="button is-light" title="Sair" @click="logout">
                        <b-icon icon="logout" custom-size="default" />
                    </a>
                </div>
            </b-navbar-item>
        </template>
    </b-navbar>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'

    export default {
        data() {
            return {
                isMenuNavBarActive: false
            }
        },
        computed: {
            menuNavBarToggleIcon() {
                return (this.isMenuNavBarActive) ? 'close' : 'dots-vertical'
            },
            menuToggleMobileIcon() {
                return this.isAsideMobileExpanded ? 'backburger' : 'forwardburger'
            },
            ...mapState('components', [
                'sidebarIsOpened'
            ])
        },
        methods: {
            ...mapActions([
                'logout'
            ]),
            menuNavBarToggle() {
                this.isMenuNavBarActive = (!this.isMenuNavBarActive)
            },
            ...mapMutations('components', [
                'setSidebar'
            ])
        }
    }
</script>
